import React from 'react';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from 'recharts';

interface PaymentMethodChartProps {
  data: Array<{ name: string; value: number }>;
}

export function PaymentMethodChart({ data }: PaymentMethodChartProps) {
  const displayData = data && data.length > 0 ? data : getDemoPaymentData();
  const sortedData = [...displayData].sort((a, b) => b.value - a.value);
  const total = displayData.reduce((sum, item) => sum + item.value, 0);

  return (
    <div
      className="rounded-2xl p-6 backdrop-blur-sm border"
      style={{
        backgroundColor: '#111116',
        borderColor: '#1e1e25',
      }}
    >
      <div className="mb-6">
        <h3 style={{ color: '#f5f5f7' }} className="text-lg font-semibold">
          Métodos de Pagamento
        </h3>
        <p style={{ color: '#8a8a95' }} className="text-sm">
          Preferência de usuários
        </p>
      </div>
      <ResponsiveContainer width="100%" height={300}>
        <BarChart data={sortedData} margin={{ top: 5, right: 30, left: 0, bottom: 5 }}>
          <CartesianGrid strokeDasharray="3 3" stroke="rgba(138, 138, 149, 0.1)" />
          <XAxis
            dataKey="name"
            stroke="#75757f"
            style={{ fontSize: '12px' }}
          />
          <YAxis stroke="#75757f" style={{ fontSize: '12px' }} />
          <Tooltip
            contentStyle={{
              backgroundColor: '#131318',
              border: '1px solid #1e1e25',
              borderRadius: '8px',
              color: '#f5f5f7',
            }}
            formatter={(value: number) => {
              const percentage = ((value / total) * 100).toFixed(1);
              return [`${value} (${percentage}%)`, 'Pagamentos'];
            }}
            cursor={{ fill: 'rgba(180, 163, 255, 0.1)' }}
          />
          <Legend wrapperStyle={{ color: '#75757f' }} />
          <Bar
            dataKey="value"
            fill="#b4a3ff"
            name="Quantidade"
            radius={[4, 4, 0, 0]}
            isAnimationActive={true}
          />
        </BarChart>
      </ResponsiveContainer>

      <div
        className="mt-6 space-y-2 border-t pt-4"
        style={{ borderColor: '#1e1e25' }}
      >
        {sortedData.map((method) => (
          <div key={method.name} className="flex justify-between text-sm">
            <span style={{ color: '#8a8a95' }}>{method.name}</span>
            <span style={{ color: '#f5f5f7' }} className="font-bold">
              {method.value} ({((method.value / total) * 100).toFixed(1)}%)
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}

function getDemoPaymentData() {
  return [
    { name: 'PIX', value: 156 },
    { name: 'Cartão de Crédito', value: 89 },
    { name: 'Boleto', value: 34 },
  ];
}
